module.exports = __webpack_public_path__ + "static/covid-vaccination-5c14a765f995b7b6358b60889e48e781.webp";